/**
 * The sync protocol between a device and the server. Shared, so both sides validate the same shapes.
 *
 * PUSH: the device sends operations from its outbox. Each has a device-made `opId`. The server
 * applies each op at most once: a retried op (e.g. the response was lost) returns the stored
 * result of the first attempt. Each op carries the full new resource plus `baseBody`, the
 * version the user edited from, so the server can merge concurrent edits (see merge.ts).
 *
 * PULL: the device asks for every change in its facility after a cursor (a server sequence number)
 * and stores the returned cursor only after the changes are safely written locally.
 */
import { z } from 'zod';
import { zId } from './fhir.js';
export const MAX_PUSH_OPS = 100;
export const DEFAULT_PULL_LIMIT = 500;
export const MAX_PULL_LIMIT = 1000;
export const zPushOp = z.object({
    opId: zId,
    resource: z.record(z.unknown()),
    /** Server version the edit was made from; null for a record the device created. */
    baseVersionId: z.string().regex(/^\d+$/).nullable(),
    /** The record as the user saw it before editing; null for a create. */
    baseBody: z.record(z.unknown()).nullable(),
});
export const zPushRequest = z.object({
    ops: z.array(zPushOp).min(1).max(MAX_PUSH_OPS),
});
export const ROLES = ['admin', 'provider', 'recorder', 'supervisor', 'observer'];
export const WRITE_ROLES = ['admin', 'provider', 'recorder'];
//# sourceMappingURL=sync.js.map